import { render, staticRenderFns } from "./TextareaContainer.vue?vue&type=template&id=ab1fb38c&scoped=true&"
import script from "./TextareaContainer.vue?vue&type=script&lang=js&"
export * from "./TextareaContainer.vue?vue&type=script&lang=js&"
import style0 from "./TextareaContainer.vue?vue&type=style&index=0&id=ab1fb38c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1fb38c",
  null
  
)

export default component.exports